<template>
  <component
    :is="link_component"
    v-tooltip.right="!is_expanded ? tooltip || label : ''"
    v-bind="link_props"
    :class="['rounded-md font-medium transition-colors duration-200', layout_class, tone_class]"
    :data-test="data_test"
    @click="onClick"
  >
    <AppIcon
      v-if="icon"
      :name="icon"
      fixed-width
      size="sm"
    />
    <span
      v-if="is_expanded"
      class="truncate text-base md:text-sm"
    >
      {{ label }}
    </span>
  </component>
</template>

<script setup>
import { computed } from 'vue';
import AppLink from '@/app/shared_components/AppLink.vue';

const props = defineProps({
  to: { type: [Object, String], default: null },
  href: { type: String, default: null },
  label: { type: String, required: true },
  icon: { type: String, default: null },
  tooltip: { type: String, default: null },
  is_active: { type: Boolean },
  is_expanded: { type: Boolean, default: true },
  tone: { type: String, default: 'nav' }, // 'nav' | 'warning'
  data_test: { type: String, default: null },
  on_click: { type: Function, default: null },
});

const link_component = computed(() => {
  if (props.to) return AppLink;
  return 'a';
});

const link_props = computed(() => {
  if (props.to) return { to: props.to, hide_underline: true };
  if (props.href) return { href: props.href, target: '_blank' };
  return { class: 'cursor-pointer' };
});

const layout_class = computed(() =>
  props.is_expanded ? 'flex items-center gap-3 px-2 py-1' : 'mx-auto flex size-9 items-center justify-center',
);

const tone_class = computed(() => {
  if (props.tone === 'warning') return 'text-warning-700 hover:bg-warning-50';
  if (props.is_active) return 'bg-selected font-semibold text-content hover:bg-selected-hover';
  return 'text-content-muted hover:bg-selected hover:text-content';
});

const onClick = (event) => {
  if (props.on_click) props.on_click(event);
};
</script>
